// extracted by mini-css-extract-plugin
export default {"container":"Logout_container__KvM9W"};